import { Box, Container, Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const InfoBlock = ({ title, items }: { title: string; items: string[] }) => (
  <Box>
    <Typography variant="h3" sx={{ mb: 1 }}>
      {title}
    </Typography>
    <Stack spacing={1}>
      {items.map((item) => (
        <Typography key={item} variant="body2" color="text.secondary">
          {item}
        </Typography>
      ))}
    </Stack>
  </Box>
);

export default function Datenschutz() {
  const { t } = useTranslation();
  const sections = t("privacy.sections", { returnObjects: true }) as Array<{ title: string; items: string[] }>;

  return (
    <Container sx={{ py: { xs: 4, md: 6 }, maxWidth: "md" }}>
      <Stack spacing={3}>
        <Box>
          <Typography variant="h1">{t("privacy.title")}</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {t("privacy.updated", { date: "06.02.2026" })}
          </Typography>
        </Box>

        <Typography variant="body1" color="text.secondary">
          {t("privacy.intro")}
        </Typography>

        {sections.map((section) => (
          <InfoBlock key={section.title} title={section.title} items={section.items} />
        ))}

        {t("privacy.note") && (
          <>
            <Divider />
            <Typography variant="caption" color="text.secondary">
              {t("privacy.note")}
            </Typography>
          </>
        )}
      </Stack>
    </Container>
  );
}
